var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoginInputNotView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5826 5.5L4.99609 18.0865L6.41031 19.5007L18.9968 6.91421L17.5826 5.5ZM6.42 15.2504L9 12.6604C8.99573 12.6071 8.99573 12.5536 9 12.5004C9 11.7047 9.31607 10.9416 9.87868 10.379C10.4413 9.81643 11.2044 9.50036 12 9.50036H12.16L13.92 7.74036C13.2931 7.57757 12.6477 7.49689 12 7.50036C7 7.50036 4 12.5004 4 12.5004C4.66987 13.5289 5.48497 14.4552 6.42 15.2504ZM15.0001 12.3402L17.5801 9.75024C18.5151 10.5454 19.3302 11.4717 20.0001 12.5002C20.0001 12.5002 17.0001 17.5002 12.0001 17.5002C11.3524 17.5037 10.707 17.423 10.0801 17.2602L11.8401 15.5002H12.0001C12.7957 15.5002 13.5588 15.1842 14.1214 14.6216C14.684 14.059 15.0001 13.2959 15.0001 12.5002C15.0044 12.447 15.0044 12.3935 15.0001 12.3402Z",
    fill: "#9EA3AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginInputNotView);
export default __webpack_public_path__ + "static/media/icon-login-input-not-view.bd742c922cb56e834dfc4fa6ac4f20cb.svg";
export { ForwardRef as ReactComponent };